"use client";

import { MoreHorizontal } from "lucide-react";
import { useI18N } from "common/hooks";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shadcn/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

interface NotificationMenuProps {
  notificationId: string;
  isUnread: boolean;
  onMarkAsRead: (id: string) => void;
}

const NotificationMenu = ({
  notificationId,
  isUnread,
  onMarkAsRead,
}: NotificationMenuProps) => {
  const i18n = useI18N();

  const handleMarkAsRead = () => {
    onMarkAsRead(notificationId);
  };

  // Only show menu if notification is unread
  if (!isUnread) {
    return null;
  }

  return (
    <div className="relative" style={{ pointerEvents: 'auto' }}>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={cn(
              "p-1 rounded-md hover:border border-border-token-neutral-minimal",
              "transition-colors focus-blue",
            )}
            aria-label={i18n.get("notificationOptions")}
          >
            <MoreHorizontal size={24} className="text-fg-neutral-strong" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="z-[1002]">
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              handleMarkAsRead();
            }}
            className="p-0"
          >
            <div className="self-stretch min-w-28 min-h-11 px-3 py-2 inline-flex justify-center items-center gap-3 flex-wrap content-center">
              <div className="flex-1 flex justify-start items-center gap-3 flex-wrap content-center">
                <div className="flex-1 min-h-6 inline-flex flex-col justify-center items-start">
                  <div className="self-stretch justify-center label-s-medium">
                    {i18n.get("markAsRead")}
                  </div>
                </div>
              </div>
            </div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default NotificationMenu;
